import CircularProgress from '@components/shared/CircularProgress'
import Tooltip from '@components/shared/Tooltip'
import { ArrowPathIcon } from '@heroicons/react/20/solid'
import { useEffect, useState } from 'react'
import { useTranslation } from 'next-i18next'

const REFETCH_ROUTE_INDICATOR_INCREMENT_PER_STEP = 5

const CircularProgressWithInterval = ({
  refetchRouteIntervalMs,
  refetchRoute,
  fetchingRoute,
}: {
  refetchRouteIntervalMs: number
  refetchRoute: (() => unknown) | undefined
  fetchingRoute: boolean
}) => {
  const { t } = useTranslation('swap')
  const [refetchRoutePercentage, setRefetchRoutePercentage] = useState(0)
  useEffect(() => {
    if (fetchingRoute) return

    let currentPercentage = 0
    const countdownInterval = setInterval(
      () => {
        if (currentPercentage < 100) {
          currentPercentage += REFETCH_ROUTE_INDICATOR_INCREMENT_PER_STEP
          setRefetchRoutePercentage(currentPercentage)
        }
      },
      refetchRouteIntervalMs /
        (100 / REFETCH_ROUTE_INDICATOR_INCREMENT_PER_STEP),
    )

    return () => {
      clearInterval(countdownInterval)
    }
  }, [fetchingRoute, refetchRouteIntervalMs])

  return refetchRoute ? (
    <Tooltip content={t('refresh-quote')}>
      <button
        className="flex items-center rounded-full text-xs text-th-fgd-1 focus:outline-none"
        onClick={refetchRoute}
      >
        <div className="relative size-6">
          <CircularProgress
            size={24}
            indicatorWidth={1}
            trackWidth={1}
            progress={refetchRoutePercentage}
          />
          <div className="absolute inset-0 flex size-6 items-center justify-center">
            <ArrowPathIcon
              className={`size-4 text-th-fgd-2 ${
                fetchingRoute ? 'animate-spin' : null
              }`}
            />
          </div>
        </div>
      </button>
    </Tooltip>
  ) : null
}

export default CircularProgressWithInterval
